/**
 * A game's score: `100 × primary + secondary`, lower is better. What each metric
 * *means* per game is not stored here — the player-facing wording lives in
 * `SCORING_RULES` (src/games/scoringRules.ts), which the Scoring-rules overlay reads.
 */
export interface ScoreBreakdown {
    primaryMetric: number;
    secondaryMetric: number;
    totalScore: number;
}

export function calculateScore(primary: number, secondary: number): ScoreBreakdown {
    return {
        primaryMetric: primary,
        secondaryMetric: secondary,
        totalScore: primary * 100 + secondary
    };
}
